import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { removeEmpty } from '@/utils/resultsHelper';
import { validationClasses } from '@/utils/errors';

const listItems = (namespace, namespaces) => {
  const items = namespaces.map(({ name }) => name);
  items.push(namespace);

  return (
    removeEmpty(Array.from(new Set(items))).sort().map((name) => ({
      key: `request_namespace_dropdown_item_${name}`,
      text: name,
      value: name,
      active: name === namespace,
    }))
  );
};

const DestinationNamespaceDropdown = ({
  disabled,
  error,
  namespaces,
  namespace,
  onChange,
}) => {
  const intl = useIntl();
  return (
    <Dropdown
      allowAdditions
      className={validationClasses(error, 'aridhia-destination-namespace-dropdown max-content')}
      disabled={disabled}
      error={error}
      fluid
      id="select_destination_namespace"
      onChange={(e, { value }) => onChange({ destination_namespace: value })}
      options={listItems(namespace, namespaces)}
      placeholder={intl.formatMessage({ id: 'access.namespace.dropdown.placeholder' })}
      search
      selection
      value={namespace}
    />
  );
};

export default DestinationNamespaceDropdown;
